<router-outlet /> <ui-notifications /> <ui-dialogs />
<ui-tooltips />
<app-demo-cookie-banner-dialog *isDemoMode />
